// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__38Jn-","large":"styles_large__12M9W"};